import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useEffect } from 'react';
import {isMobileOnly} from 'react-device-detect';

const ThumbnailImgBlock = styled.div`
    width:${(props) => (props.width)}px;
    height:${(props) => (props.height)}px;
    margin: ${isMobileOnly?`0 5px 0`:`0 0 10px`};
`;

const IMG = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 4px;

`;

const ThumbnailImg = ({ img, width, height, mouseover }) => {

    const [curImg, setCurImg] = useState(img);

    useEffect(() => {
        setCurImg(img);
    }, [img])

    const handleMouseEnter = () => {
        mouseover(curImg);
        document.body.style.cursor = "pointer";
    }

    const handleMouseLeave = () => {
        document.body.style.cursor = "default";
    }

    return (
        <ThumbnailImgBlock width={width} height={height} >
            <IMG src={img} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
        </ThumbnailImgBlock>
    );
};

export default ThumbnailImg;
